<template>
  <div>
    <b-overlay :show="loading">
      <b-row
        v-if="isGroup && !(isGroupHeadRole() || currentParvandehCode)"
        class="m-0 px-md-3"
      >
        <b-col>
          <b-alert show variant="warning" class="font-weight-bold">
            <i class="fas fa-info-circle fa-lg mr-2" />
            <span
              v-text="'در حال حاضر هیچ پرونده ای جهت رای گیری در جریان نیست'"
            />
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-else class="m-0 px-md-3">
        <b-col cols="12" md="3" class="px-md-0 mb-mdi mb-3">
          <b-row>
            <b-col cols="12" md="12" class="mb-3">
              <div class="bg-white border rounded p-2 z-index-99">
                <div
                  class="image_box text-center flex-center position-relative"
                >
                  <div
                    @click="showWindowModal(true, 'slider')"
                    class="position-absolute top-0 left-0 w-100 h-100 cursor_pointer z-index-1"
                  />
                  <ImageBox
                    :downloadCode="
                      pathOr(null, ['person', 'download_code'], generalData)
                    "
                    imageClass="width-150 border-radius-4 bg-white cursor_pointer border"
                    :defaultImage="defaultImage"
                    loadingClass="left-0 top-0 width-150 border-radius-4"
                    :hasPreview="false"
                  />
                  <!-- <b-img
                    class="cursor_pointer"
                    v-b-tooltip.hover
                    :title="$lang.clickShowSlider"
                    thumbnail
                    fluid
                    width="150"
                    :onerror="$config.images.onerrorDefaultImg"
                    :src="
                      pathOr(
                        defaultImg,
                        ['person', 'attachment', 'url'],
                        generalData
                      )
                    "
                    @click="showWindowModal(true, 'slider')"
                  /> -->
                </div>
                <div
                  class="my-2 fs_1rem font-weight-bold text-center w-100 color-complementary"
                >
                  <ProfileBoxPopupWrapper
                    :data="generalData"
                    deskTopPopupClass="top-230"
                  />
                </div>
                <ul class="list-unstyled m-0 fs_14">
                  <li class="mb-1">
                    <strong v-text="`${$lang.term}: `" />
                    <span
                      class="text-muted"
                      v-text="
                        pathOr('', ['person', 'term', 'caption'], generalData)
                      "
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.registrationNumber}: `" />
                    <span
                      class="text-muted"
                      v-text="
                        pathOr('', ['person', 'parvandeh_number'], generalData)
                      "
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.license_caption}: `" />
                    <span
                      class="text-muted"
                      v-text="
                        pathOr(
                          '',
                          ['person', 'license', 'caption'],
                          generalData
                        )
                      "
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.birth_date}: `" />
                    <span
                      class="text-muted"
                      v-text="
                        pathOr(
                          '',
                          ['person', 'birth_date', 'jalali'],
                          generalData
                        )
                      "
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.national_code}: `" />
                    <span
                      class="text-muted"
                      v-text="
                        pathOr('', ['person', 'national_code'], generalData)
                      "
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.mobile}: `" />
                    <span
                      class="text-muted"
                      v-text="pathOr('', ['person', 'mobile'], generalData)"
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.marital_status}: `" />
                    <span
                      class="text-muted"
                      v-text="
                        pathOr('', ['person', 'marriage_caption'], generalData)
                      "
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.resident}: `" />
                    <span
                      class="text-muted"
                      v-text="
                        pathOr(
                          '',
                          ['person', 'sokonat_location_caption'],
                          generalData
                        )
                      "
                    />
                  </li>
                  <li class="mb-1">
                    <strong v-text="`${$lang.allegiance}: `" />
                    <span
                      class="text-muted"
                      v-text="pathOr('', ['person', 'allegiance'], generalData)"
                    />
                  </li>
                </ul>
                <b-button
                  variant="link"
                  class="text-primary py-0"
                  block
                  @click="showWindowModal(true, 'profileWindow')"
                  v-text="$lang.read_more"
                />
              </div>
            </b-col>
            <b-col cols="12" md="12" class="mb-3">
              <ScoreWindow
                ref="scoreWindow"
                componentType="reportConclusion"
                :code="code"
                :calculateData="calculateData"
                :callInCreatedHook="false"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="9">
          <ReadMoreTable
            :title="$lang.final_report_education"
            :fields="educationFields"
            :items="educationItems"
            :hasNextBtn="showNextBtn"
            @next="next"
            @showWindowModal="showWindowModal"
          />
          <ReadMoreTable
            v-if="$customConfig.isFinalReportInterviewSummarize"
            :title="$lang.finalReportInterviewSummarize"
            :fields="interviewSummarizeFields"
            :items="interviewSummarizeItems"
            :readMoreLink="false"
          />
          <ReadMoreTable
            :title="$lang.inquiry_requirements"
            :fields="inquiryRequirementsFields"
            :items="inquiryRequirementsItems"
            :readMoreLink="false"
          />
          <b-row align-v="center" align-h="center" class="mx-0 mt-2">
            <b-col
              cols="12"
              md=""
              class="px-1 mb-1"
              v-for="(button, index) in showExamPackModalButtons"
              :key="`a-${index}`"
            >
              <b-button
                block
                variant="info"
                class="border-0 rounded-0"
                v-text="button.label"
                @click="showExamPackModal(button)"
              />
            </b-col>
            <b-col
              cols="12"
              md=""
              class="px-1 mb-1"
              v-for="(button, index) in filterButtons"
              :key="`b-${index}`"
            >
              <b-button
                block
                variant="info"
                class="border-0 rounded-0"
                v-text="button.label"
                :disabled="pathOr(false, ['disabled'], button)"
                @click="
                  showWindowModal(
                    true,
                    button.componentName,
                    button.componentType
                  )
                "
              />
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="12" md="12" class="md-mb-0 mb-2">
              <div class="border rounded p-2 bg-white">
                <div
                  class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2"
                >
                  <strong v-text="$lang.researchAbstract" />

                  <span
                    v-if="
                      !isFinalReportVotes3 &&
                      pathOr(false, ['research_summary_editable'], generalData)
                    "
                    class="text-success cursor_pointer"
                    v-b-tooltip.hover
                    :title="$lang.edit_analyze_summary"
                    @click="showResearchSummaryForm"
                  >
                    <mdicon name="file-document-edit-outline" size="20" />
                  </span>
                </div>
                <p
                  v-if="!editResearchSummary"
                  class="mt-2 text-muted text-justify text-break fs_13 font-weight-bold"
                  v-html="nl2br(pathOr('', ['research_summary'], generalData))"
                />
                <b-row v-else>
                  <b-col cols="12" md="12">
                    <LoadingSpinner
                      :loading="editResearchSummaryLoading"
                      :text="$lang.sending_data"
                    />
                  </b-col>
                  <b-col v-if="!editResearchSummaryLoading" cols="12" md="12">
                    <b-form-group>
                      <b-form-textarea
                        id="researchSummaryText"
                        type="text"
                        v-model="$v.researchSummaryText.$model"
                        :state="
                          $v.researchSummaryText.$dirty
                            ? !$v.researchSummaryText.$error
                            : null
                        "
                        autocomplete="off"
                        rows="10"
                      >
                      </b-form-textarea>
                      <b-form-invalid-feedback
                        id="researchSummaryText-feedback"
                      >
                        {{
                          $lang.error_required
                            | replace($lang.edit_research_summary)
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col
                    v-if="!editResearchSummaryLoading"
                    cols="12"
                    md="12"
                    class="text-right"
                  >
                    <b-button
                      size="sm"
                      class="mr-2"
                      variant="outline-danger"
                      @click="cancelResearchSummaryForm"
                    >
                      <mdicon name="close" size="20" />
                      {{ $lang.cancelButton }}
                    </b-button>
                    <b-button
                      variant="success"
                      size="sm"
                      @click="updateResearchSummary"
                    >
                      <mdicon name="check" size="20" />
                      {{ $lang.submitButton }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="m-0 mt-2" v-if="!isFinalReportVotes3">
            <b-col cols="12" md="12" class="border rounded p-0 bg-white">
              <b-overlay :show="voteLoading" class="p-2">
                <b-row>
                  <b-col>
                    <strong v-text="$lang.voteGroup" />
                  </b-col>
                  <b-col cols="auto" md="auto" v-if="!isBoardSecretary">
                    <b-button
                      v-if="showNextBtn"
                      block
                      variant="primary"
                      @click="next()"
                    >
                      <span v-text="$lang.submitNext" />
                      <i class="fas fa-chevron-left ml-2" />
                    </b-button>
                  </b-col>
                </b-row>
                <ul class="list-unstyled m-0 mt-3 px-0 text-left">
                  <li
                    class="mb-2 fs_12"
                    v-for="(item, index) in votesDataMaped"
                    :key="`c-${index}`"
                  >
                    <div
                      class="w-full"
                      v-b-tooltip.hover
                      :title="item.tooltip"
                    >
                      <strong v-text="`${index + 1}- `" />
                      <strong class="text-danger" v-text="item.voteLevel" />
                      <strong v-text="item.voteCaption" />
                      <strong v-if="item.description">
                        <span v-text="' - '" />
                        <span
                          class="text-danger"
                          v-text="`${$lang.description}: `"
                        />
                        <span v-html="item.description" />
                      </strong>
                    </div>
                  </li>
                </ul>
                <b-row
                  class="m-0 mt-4"
                  v-if="isAdmin(permissions) && !isBoardSecretary"
                >
                  <b-col cols="12" md="auto">
                    <b-form-group
                      :label="`${$lang.final_report_vote_options}: `"
                      label-for="vote_options"
                      label-cols="auto"
                    >
                      <requiredComponent
                        slot="label"
                        :label="`${$lang.final_report_vote_options}: `"
                        :rules="$v.vote_selected.$params"
                      />
                      <selectFind
                        :options="vote_options"
                        v-model="$v.vote_selected.$model"
                        label="text"
                        id="value"
                        :isValid="
                          $v.vote_selected.$dirty
                            ? !$v.vote_selected.$error
                            : null
                        "
                      />
                      <b-form-invalid-feedback
                        :style="{
                          display: $v.vote_selected.$error ? 'block' : 'none',
                        }"
                        id="vote_selected_feedback"
                      >
                        {{
                          $lang.error_required
                            | replace($lang.final_report_vote_options)
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="">
                    <b-form-group
                      :label="`${$lang.final_report_vote_description}: `"
                      label-for="description"
                      label-cols="auto"
                    >
                      <requiredComponent
                        slot="label"
                        :label="`${$lang.final_report_vote_description}: `"
                        :rules="$v.description.$params"
                      />
                      <b-form-input type="text" v-model="$v.description.$model">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="auto">
                    <b-button block variant="success" @click="submit(false)">
                      <mdicon name="check" size="20" />
                      <span v-text="$lang.submitVote" class="ml-1" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-col>
            <b-col
              v-if="isBoardSecretary"
              cols="12"
              md="12"
              class="border rounded p-0 bg-white mt-2"
            >
              <b-overlay :show="boardSecretaryLoading" class="p-2">
                <b-row>
                  <b-col />
                  <b-col
                    cols="auto"
                    md="auto"
                    class="d-flex align-items-center"
                    v-if="isBoardSecretary && isAdmin(permissions)"
                  >
                    <span
                      class="bg-light p-2 rounded mr-3 d-flex align-items-center justify-content-between"
                    >
                      <strong>{{ $lang.status }}: </strong>
                      <span class="text-muted ml-1">{{
                        pathOr("", ["caption"], statusSelected)
                      }}</span>
                      <b-button
                        variant="outline-dark"
                        class="ml-2"
                        size="sm"
                        @click="showChangeStatusModal"
                      >
                        <span v-text="$lang.change_status" />
                      </b-button>
                    </span>
                    <b-button
                      v-if="showNextBtn"
                      variant="primary"
                      @click="next()"
                    >
                      <span v-text="$lang.submitNext" class="mr-1" />
                      <mdicon name="chevron-left" size="20" />
                    </b-button>
                  </b-col>
                </b-row>
                <ul class="list-unstyled m-0 mt-3 px-0 text-left">
                  <li
                    class="mb-2 fs_12"
                    v-for="(item, index) in boardSecretaryDataMaped"
                    :key="`d-${index}`"
                  >
                    <div
                      class="w-full"
                      v-b-tooltip.hover
                      :title="item.tooltip"
                    >
                      <strong v-text="`${index + 1}- `" />
                      <strong class="text-danger" v-text="item.voteLevel" />
                      <strong v-text="item.voteCaption" />
                      <strong v-if="item.description">
                        <span v-text="' - '" />
                        <span
                          class="text-danger"
                          v-text="`${$lang.description}: `"
                        />
                        <span v-html="item.description" />
                      </strong>
                    </div>
                  </li>
                </ul>
                <b-row class="m-0 mt-4" v-if="isAdmin(permissions)">
                  <b-col cols="12" md="8">
                    <b-form-group label-for="vote_options" label-cols="auto">
                      <requiredComponent
                        slot="label"
                        :label="`${$lang.board_secretary_comment}: `"
                        :rules="$v.vote_selected.$params"
                      />
                      <selectFind
                        :options="board_secretary_vote_options"
                        v-model="$v.vote_selected.$model"
                        label="text"
                        id="value"
                        :isValid="
                          $v.vote_selected.$dirty
                            ? !$v.vote_selected.$error
                            : null
                        "
                      />
                      <b-form-invalid-feedback
                        :style="{
                          display: $v.vote_selected.$error ? 'block' : 'none',
                        }"
                        id="vote_selected_feedback"
                      >
                        {{
                          $lang.error_required
                            | replace($lang.final_report_vote_options)
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="12">
                    <b-row>
                      <b-col cols="12" md="">
                        <b-form-group label-for="description" label-cols="auto">
                          <requiredComponent
                            slot="label"
                            :label="`${$lang.final_report_vote_description}: `"
                            :rules="$v.description.$params"
                          />
                          <b-form-input
                            type="text"
                            v-model="$v.description.$model"
                          >
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="auto">
                        <b-button
                          block
                          variant="success"
                          @click="submit(false)"
                        >
                          <mdicon name="check" size="20" />
                          <span v-text="$lang.submitVote" class="ml-1" />
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-overlay>
    <b-modal
      v-model="windowModal"
      :size="modalSize"
      ok-only
      hide-footer
      hide-header
    >
      <b-overlay :show="modalLoading">
        <b-row class="m-0">
          <b-col cols="12">
            <component
              :is="windowComponentName"
              @loading="updateModalLoading"
              @setLoading="updateModalLoading"
              :componentType="windowComponentType"
              :personCode="currentPersonCode"
              :code="code"
              :slides="files"
            />
          </b-col>
          <b-col cols="12" class="text-right">
            <b-button
              v-if="windowComponentName === 'slider'"
              class="mt-3 mr-2"
              variant="dark"
              @click="setModalSize()"
            >
              {{ modalSizeBtnTitle }}
              <i class="fas fa-expand"></i>
            </b-button>
            <b-button
              class="mt-3"
              variant="outline-danger"
              @click="showWindowModal()"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
          </b-col>
        </b-row>
      </b-overlay>
    </b-modal>
    <b-modal
      v-model="examPacksModal"
      size="xl"
      ok-only
      hide-header
      no-close-on-backdrop
    >
      <b-card>
        <div slot="header">
          {{ examPacksModalTitle }}
        </div>
        <LoadingSpinner :loading="examPacksLoading" />
        <b-tabs v-if="!examPacksLoading">
          <b-tab
            v-for="(examPack, index) in examPackItems"
            :key="`e-${index}`"
            :lazy="true"
            :active="!index"
          >
            <template v-slot:title>
              {{ renderExamPackTitle(examPack) }}
            </template>
            <ExamPackType3
              :showTitle="false"
              :withProps="true"
              :resourceCode="
                pathOr(null, ['azmoon_execute_person_code'], examPack)
              "
              :examPackId="pathOr(null, ['exam_pack', 'id'], examPack)"
              :parvandehCode="
                pathOr(null, ['person', 'parvandeh_code'], generalData)
              "
            />
          </b-tab>
        </b-tabs>
      </b-card>
      <template #modal-footer>
        <div class="float-left">
          <b-button
            class="mr-2"
            variant="outline-danger"
            @click="examPacksModal = false"
          >
            <mdicon name="close" size="20" />
            {{ $lang.close }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      v-model="changeStatusModal"
      size="sm"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <b v-text="$lang.change_status" />
        </div>
        <LoadingSpinner
          :loading="changeStatusLoading"
          :text="$lang.sending_data"
        />
        <b-row v-show="!changeStatusLoading">
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.status}: `"
                :rules="$v.statusSelected.$params"
              />
              <selectFind
                :options="statusOptions"
                v-model="$v.statusSelected.$model"
                label="caption"
                id="id"
                :isValid="
                  $v.statusSelected.$dirty ? !$v.statusSelected.$error : null
                "
              />
              <b-form-invalid-feedback
                :state="
                  $v.statusSelected.$dirty ? !$v.statusSelected.$error : null
                "
              >
                <div v-if="!$v.statusSelected.required">
                  {{ $lang.error_required | replace($lang.status) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="text-right">
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="closeChangeStatusModal"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button variant="success" @click="changeStatus">
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>
<script>
import ReadMoreTable from "./components/votes2/readMoreTable";
import matrixTextTable from "@/components/global/MatrixTextTable";
import colorList from "./components/votes2/colorList";
import profileWindow from "./components/votes2/profileWindow";
import educationWindow from "./components/votes2/educationWindow";
import slider from "./components/votes2/slider";
import ScoreWindow from "./components/votes2/scoreWindow";
import characterWindow from "./components/votes2/characterWindow";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import ExamPackType3 from "@/components/report/examPackType3";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import {
  renderEumOptions,
  fullScreen,
  isAdmin,
  generateApiUrl,
  nl2br,
  generateStoreGetters,
  generateConfig,
} from "@/shared/utils";
import { ImageBox, ProfileBoxPopupWrapper } from "@/components/re-design";

export default {
  name: "final-report-votes2",
  inject: ["finalReportVotesRepository"],
  components: {
    ReadMoreTable,
    matrixTextTable,
    colorList,
    profileWindow,
    educationWindow,
    characterWindow,
    slider,
    ScoreWindow,
    LoadingSpinner,
    ExamPackType3,
    ProfileBoxPopupWrapper,
    ImageBox,
  },
  validations: {
    vote_selected: { required },
    description: {},
    researchSummaryText: { required },
    statusSelected: { required },
  },
  data() {
    return {
      loading: false,
      voteLoading: false,
      modalLoading: false,
      nextLoading: false,
      modalSize: "xl",
      modalSizeBtnTitle: "تصویر معمولی",
      defaultImg: this.$config.images.tinyLogo,
      generalData: null,
      files: [],
      educationData: [],
      enteringAzmoonData: [],
      inquiryData: [],
      votesData: [],
      vote_selected: null,
      description: null,
      code: this.$route.params.code,
      isGroup: this.$route.name === "finalReportVotesGroup",
      isFinalReportVotes3: this.$route.name === "finalReportVotes3",
      currentParvandehCode: null,
      nextParvandehCode: null,
      currentPersonCode: "",
      voteStateQueue: null,
      votesQueue: null,
      queueTime: 5000, // 5 second for refreshing services
      windowModal: false,
      windowComponentName: null,
      windowComponentType: null,
      educationFields: [
        {
          key: "score0",
          label: "مقطع تحصیلی",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score1",
          label: "رشته تحصیلی",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score2",
          label: "واحد آموزشی",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score3",
          label: "از سال تا سال",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
      ],
      interviewSummarizeFields: [
        {
          key: "score0",
          label: "نمره تراز",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score1",
          label: "رتبه در سهمیه",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score2",
          label: "نوع سهمیه",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score3",
          label: "حوزه قضایی پذیرفته شده",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
      ],
      inquiryRequirementsFields: [
        {
          key: "score0",
          label: "نوع استعلام",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score1",
          label: "نتیجه",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
        {
          key: "score2",
          label: "تاریخ",
          class: "text-center",
          thClass: "p-1",
          tdClass: "p-1 text-muted",
        },
      ],
      permissions: [],
      examPacksModal: false,
      examPacksLoading: false,
      examPacksModalTitle: "",
      examPackItems: [],
      boardSecretaryLoading: false,
      boardSecretaryData: [],
      editResearchSummary: false,
      researchSummaryText: null,
      editResearchSummaryLoading: false,

      // change status data
      parvandehCode: null,
      statusSelected: null,
      changeStatusLoading: false,
      changeStatusModal: false,
    };
  },
  computed: {
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
    isBoardSecretary() {
      const roles = generateStoreGetters(["userInfo", "roles"]) || [];
      return includes("board_secretary", roles);
    },
    educationItems() {
      const educationLastGrade =
        this.educationData &&
        this.educationData.find((item) => item.is_last_grade);
      return educationLastGrade
        ? [
            {
              score0: pathOr(
                "",
                ["education_grade", "caption"],
                educationLastGrade
              ),
              score1: pathOr("", ["education_field"], educationLastGrade),
              score2: pathOr("", ["education_place"], educationLastGrade),
              score3: `${pathOr(
                "",
                ["from_year"],
                educationLastGrade
              )} تا ${pathOr("", ["to_year"], educationLastGrade)}`,
            },
          ]
        : [];
    },
    inquiryRequirementsItems() {
      return this.inquiryData.map((item) => {
        return {
          score0: pathOr("", ["inquiry_type", "caption"], item),
          score1: pathOr("", ["inquiry_result", "caption"], item),
          score2: pathOr("", ["inquiry_date", "jalali"], item),
        };
      });
      /* return [
        {
          score0: pathOr(
            "",
            ["inquiries", "inquiry_madrak"],
            this.inquiryData
          ),
          score1: pathOr(
            "",
            ["inquiries", "inquiry_soe_pishineh"],
            this.inquiryData
          ),
          score2: pathOr(
            "",
            ["inquiries", "inquiry_vaja"],
            this.inquiryData
          ),
          score3: pathOr(
            "",
            ["inquiries", "inquiry_hefa"],
            this.inquiryData
          ),
        },
      ]; */
    },
    interviewSummarizeItems() {
      return [
        {
          score0: pathOr("", ["level"], this.enteringAzmoonData),
          score1: pathOr("", ["rank"], this.enteringAzmoonData),
          score2: pathOr("", ["quota_caption"], this.enteringAzmoonData),
          score3: pathOr(
            "",
            ["hoze_ghazaei_location_caption"],
            this.enteringAzmoonData
          ),
        },
      ];
    },
    vote_options() {
      return renderEumOptions("final_report_vote");
    },
    board_secretary_vote_options() {
      return renderEumOptions("final_report_board_secretary_vote");
    },
    showNextBtn() {
      return (
        ((this.isGroup && this.isGroupHeadRole()) || !this.isGroup) &&
        !this.nextLoading &&
        !this.isFinalReportVotes3
      );
    },
    votesDataMaped() {
      return this.votesData.map((item) => {
        const voteNumber = pathOr(1, ["vote_number"], item);
        const fullName = pathOr(null, ["registrant"], item)
          ? `${pathOr("", ["registrant", "name"], item)} ${pathOr(
              "",
              ["registrant", "family"],
              item
            )}`
          : "";
        return {
          ...item,
          voteCaption: pathOr(null, ["vote", "caption"], item),
          voteLevel: `${fullName}${
            voteNumber > 1 ? ` (رای مرحله ${voteNumber})` : ""
          }: `,
          tooltip: `زمان رأی: ${pathOr("", ["created_at", "jalali"], item)}`,
        };
      });
    },
    boardSecretaryDataMaped() {
      return this.boardSecretaryData.map((item) => {
        const voteNumber = pathOr(1, ["vote_number"], item);
        const fullName = pathOr(null, ["registrant"], item)
          ? `${pathOr("", ["registrant", "name"], item)} ${pathOr(
              "",
              ["registrant", "family"],
              item
            )}`
          : "";
        return {
          ...item,
          voteCaption: pathOr(null, ["vote", "caption"], item),
          voteLevel: `${fullName}${
            voteNumber > 1 ? ` (رای مرحله ${voteNumber})` : ""
          }: `,
          tooltip: `زمان رأی: ${pathOr("", ["created_at", "jalali"], item)}`,
        };
      });
    },
    filterButtons() {
      const calculateData = pathOr(false, ["calculate_data"], this.generalData);
      const buttons = [
        {
          label: this.$lang.reportSearchLabel,
          componentName: "scoreWindow",
          componentType: "reportSearch",
          show: !calculateData,
        },
        {
          label: this.$lang.reportInterviewLabel,
          componentName: "scoreWindow",
          componentType: "reportInterview",
          show: !calculateData,
        },
        {
          label: this.$lang.reportCharacterLabel,
          componentName: "characterWindow",
          componentType: "",
          disabled: true,
        },
        {
          label: this.$lang.reportResearchResourceLabel,
          componentName: "scoreWindow",
          componentType: "reportResource",
          disabled: true,
        },
      ];
      return buttons.filter((button) => pathOr(true, ["show"], button));
    },
    statusOptions() {
      return renderEumOptions("final_report_status").map((item) => {
        return {
          caption: pathOr("", ["text"], item),
          id: pathOr("", ["value"], item),
        };
      });
    },
    calculateData() {
      return pathOr(false, ["calculate_data"], this.generalData);
    },
    showExamPackModalButtons() {
      const calculateData = pathOr(false, ["calculate_data"], this.generalData);
      const buttons = [
        {
          label: this.$lang.reportSearchLabel,
          resource: "research_in_queue",
        },
        {
          label: this.$lang.reportInterviewLabel,
          resource: "interview_done",
        },
      ];
      return calculateData ? buttons : [];
    },
    defaultImage() {
      return generateConfig(["images", "logo"]);
    },
  },
  watch: {
    "$route.params.code": {
      handler(beforeCode, afterCode) {
        if (beforeCode && afterCode && beforeCode !== afterCode) {
          this.getNextData();
        }
      },
      deep: true,
      immediate: true,
    },
    roles: {
      handler(value) {
        if (value.length) {
          this.getNextData();
        }
      },
    },
  },
  destroyed() {
    this.destroyedAllQueue();
  },
  methods: {
    pathOr,
    includes,
    fullScreen,
    isAdmin,
    generateApiUrl,
    nl2br,
    setModalSize(forceSize = null) {
      this.modalSize = forceSize || this.modalSize === "md" ? "lg" : "md";
      this.modalSizeBtnTitle =
        this.modalSize === "md" ? "بزرگنمایی تصویر" : "تصویر معمولی";
    },
    showWindowModal(state = false, componentName = null, componentType = null) {
      // componentType parameter just for scoreWindow components
      this.modalSize = "xl";
      this.windowModal = state;
      this.windowComponentName = componentName;
      this.windowComponentType = componentType;
      if (componentName === "slider") {
        this.getAllFiles();
      }
    },
    updateModalLoading(state = true) {
      this.modalLoading = state;
    },
    getFullName(data) {
      return data
        ? `${pathOr("", ["name"], data)} ${pathOr("", ["family"], data)}`
        : "";
    },
    resetVoteSelected() {
      const enumKey = this.isBoardSecretary
        ? "final_report_board_secretary_vote"
        : "final_report_vote";
      this.vote_selected = renderEumOptions(enumKey).find(
        (item) => item.text === "بلامانع"
      );
      this.description = null;
    },
    resetAllData() {
      this.generalData = null;
      this.files = [];
      this.educationData = [];
      this.enteringAzmoonData = [];
      this.votesData = [];
      this.boardSecretaryData = [];
      this.resetVoteSelected();
    },
    isGroupHeadRole() {
      return this.isBoardSecretary;
    },
    refreshingData() {
      this.destroyedAllQueue();
      if (!this.isGroupHeadRole()) {
        this.voteStateQueue = setInterval(
          this.getCurrentParvandeh,
          this.queueTime
        );
      }
      if (this.isGroupHeadRole() || this.currentParvandehCode) {
        this.votesQueue = setInterval(this.getVotes, this.queueTime);
      }
    },
    destroyedAllQueue() {
      clearInterval(this.voteStateQueue);
      clearInterval(this.votesQueue);
    },
    next(nextState = true) {
      if (!nextState || !this.nextParvandehCode) {
        return false;
      }

      this.$router.push({
        name: this.isGroup ? "finalReportVotesGroup" : "finalReportVotes2",
        params: {
          code: this.nextParvandehCode,
        },
      });
    },
    async getGeneral() {
      // check requirement
      if (!this.code) return;

      try {
        this.loading = true;
        const query = !this.isFinalReportVotes3 ? { show_next_person: 1 } : {};
        const url = generateApiUrl(
          ["report", "final_report_general"],
          [this.code],
          query
        );
        const response = await this.$httpService.get(url);
        this.generalData = pathOr(null, ["data", "data"], response);
        this.statusSelected = pathOr(null, ["status"], this.generalData);
        this.currentPersonCode = pathOr(
          "",
          ["data", "data", "person", "code"],
          response
        );
        this.nextParvandehCode = pathOr(
          null,
          ["data", "data", "next_person"],
          response
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async getAllFiles() {
      // check requirement
      if (!this.currentPersonCode) {
        return false;
      }

      this.setModalSize("lg");

      try {
        this.modalLoading = true;
        const parvandehCode = pathOr(
          null,
          ["person", "parvandeh_code"],
          this.generalData
        );
        const url =
          this.$config.api_url +
          this.$config.report.final_report_images.replace("{0}", parvandehCode);
        const response = await this.$httpService.get(url);

        this.files = pathOr([], ["data", "data", "files"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.modalLoading = false;
      }
    },
    async getPrimaryEducation() {
      // check requirement
      if (!this.currentPersonCode) return;

      try {
        const url = generateApiUrl(
          ["report", "person_education"],
          [this.currentPersonCode]
        );
        const response = await this.$httpService.get(url);
        this.educationData = [
          ...pathOr([], ["data", "data", "result"], response),
        ];
      } catch (error) {
        this.$generateError(error);
      }
    },
    async getEnteringAzmoon() {
      // check requirement
      if (!this.code) return;

      try {
        const url = generateApiUrl(
          ["report", "final_report_entering_azmoon"],
          [this.code]
        );
        const response = await this.$httpService.get(url);
        this.enteringAzmoonData = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async getInquiry() {
      // check requirement
      if (!this.code) return;

      try {
        const url = generateApiUrl(
          ["report", "parvandehInquiries"],
          [this.code]
        );
        const response = await this.$httpService.get(url);
        this.inquiryData = pathOr([], ["data", "data", "result"], response);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async getVotes(isBoardSecretary = false) {
      // check requirement
      if (!this.code || this.isFinalReportVotes3) return;

      try {
        let queryString = { order_by: "id:asc" };
        if (isBoardSecretary) {
          queryString = { ...queryString, is_secretary: 1 };
        }
        const url = generateApiUrl(
          ["report", "final_report_votes"],
          [this.code],
          queryString
        );
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        if (isBoardSecretary) {
          this.boardSecretaryData = pathOr([], ["result"], data);
        } else {
          this.votesData = pathOr([], ["result"], data);
        }
        this.permissions = response.data.permissions;
      } catch (error) {
        this.$generateError(error);
      }
    },
    async submit(nextState) {
      // check requirement
      if (!this.code) return;

      this.$v.$touch();
      if (this.$v.vote_selected.$anyError || this.$v.description.$anyError) {
        this.isLoading = false;
        return;
      }
      const payload = {
        vote: pathOr(null, ["value"], this.vote_selected),
        description: this.description,
      };
      try {
        let queryString = null;
        if (this.isBoardSecretary) {
          this.boardSecretaryLoading = true;
          queryString = "is_secretary=1";
        } else {
          this.voteLoading = true;
        }
        const response = await this.finalReportVotesRepository.create(
          this.code,
          payload,
          queryString
        );
        await this.getVotes(this.isBoardSecretary);
        this.resetVoteSelected();
        this.$notify.success(response.data.message);
        this.next(nextState);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.voteLoading = false;
        this.boardSecretaryLoading = false;
      }
    },
    async fetchSingleVoteData() {
      // check requirement
      if (this.isGroup && !this.isGroupHeadRole() && !this.currentParvandehCode)
        return;

      try {
        this.nextLoading = true;
        this.resetAllData();
        await this.getGeneral();
        await this.getPrimaryEducation();
        await this.getEnteringAzmoon();
        await this.getInquiry();
        /* calling getFinalReportScore method of scoreWindow component when route params has been changed */
        this.$refs.scoreWindow.getFinalReportScore();
        if (this.isBoardSecretary) {
          await this.getVotes(true); // get board secretary votes
          await this.getVotes(); // get normal votes
        } else {
          await this.getVotes(); // get normal votes
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.nextLoading = false;
      }
    },
    async getNextData() {
      this.code = this.$route.params.code;
      if (this.isGroup) {
        this.fetchGroupVoteData();
      } else {
        this.fetchSingleVoteData();
      }
    },
    async setCurrentParvandeh() {
      // check requirement
      if (!this.code || !this.isBoardSecretary) {
        return false;
      }

      try {
        const url =
          this.$config.api_url +
          this.$config.report.final_report_set_current_parvandeh.replace(
            "{0}",
            this.code
          );
        await this.$httpService.patch(url);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async getCurrentParvandeh() {
      // check requirement
      if (this.isGroupHeadRole()) return;

      try {
        const url =
          this.$config.api_url + this.$config.report.final_report_see_head_team;
        const response = await this.$httpService.get(url);
        this.currentParvandehCode = pathOr(
          null,
          ["data", "data", "parvandeh_code"],
          response
        );

        if (
          this.currentParvandehCode &&
          this.currentParvandehCode !== this.code
        ) {
          this.$notify.warning("انتقال به پرونده بعدی توسط سرتیم هیئت...");
          this.nextParvandehCode = this.currentParvandehCode;
          this.next();
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    async fetchGroupVoteData() {
      await this.setCurrentParvandeh();
      await this.getCurrentParvandeh();
      await this.fetchSingleVoteData();
      this.refreshingData();
    },
    async showExamPackModal(item) {
      try {
        this.examPacksLoading = true;
        this.examPacksModalTitle = pathOr("", ["label"], item);
        this.examPacksModal = true;
        const resource = pathOr(null, ["resource"], item);
        const parvandehCode = pathOr(
          null,
          ["person", "parvandeh_code"],
          this.generalData
        );
        const url = generateApiUrl(
          ["report", "research_exam_packs"],
          [parvandehCode],
          { resource }
        );
        const response = await this.$httpService.get(url);
        this.examPackItems = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.examPacksLoading = false;
      }
    },
    cancelResearchSummaryForm() {
      this.researchSummaryText = null;
      this.editResearchSummary = false;
    },
    showResearchSummaryForm() {
      this.researchSummaryText = pathOr(
        null,
        ["research_summary"],
        this.generalData
      );
      this.editResearchSummary = true;
    },
    async updateResearchSummary() {
      this.$v.researchSummaryText.$touch();
      if (this.$v.researchSummaryText.$anyError) return;

      try {
        this.editResearchSummaryLoading = true;
        const parvandehCode = pathOr(
          null,
          ["person", "parvandeh_code"],
          this.generalData
        );
        const url = generateApiUrl(
          ["report", "final_report_research_summary"],
          [parvandehCode]
        );
        const payload = {
          research_summary: this.researchSummaryText,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.generalData.research_summary = this.researchSummaryText;
        this.editResearchSummary = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.editResearchSummaryLoading = false;
      }
    },
    showChangeStatusModal() {
      this.parvandehCode = pathOr(
        null,
        ["person", "parvandeh_code"],
        this.generalData
      );
      this.statusSelected =
        this.statusSelected || pathOr(null, ["status"], this.generalData);
      this.changeStatusModal = true;
    },
    closeChangeStatusModal() {
      this.parvandehCode = null;
      this.changeStatusModal = false;
    },
    async changeStatus() {
      try {
        this.changeStatusLoading = true;
        const url = generateApiUrl(
          ["report", "final_report_status"],
          [this.parvandehCode]
        );
        const payload = {
          status_id: pathOr(null, ["id"], this.statusSelected),
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeChangeStatusModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeStatusLoading = false;
      }
    },
    renderExamPackTitle(examPack) {
      const caption = pathOr("", ["exam_pack", "caption"], examPack);
      const lastAnswerTime = pathOr(
        "",
        ["exam_pack", "last_answer_time", "jalali"],
        examPack
      );
      return `${caption} - ${lastAnswerTime}`;
    },
  },
};
</script>
